import { computed, defineComponent, reactive, watch } from 'vue';
import { useModelWrapper } from '@hems/util';
export default defineComponent({
    name: 'VCalendarWrapper',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [Date, Object],
            required: true,
        },
        isRange: Boolean,
        mode: {
            type: String,
            default: 'date',
        },
        locale: {
            type: String,
            default: null,
        },
        minDate: Date,
        maxDate: Date,
        validate: Function,
    },
    emits: ['update:modelValue', 'close'],
    setup(props, { emit }) {
        const state = reactive({
            open: useModelWrapper(props, emit, 'open'),
            value: props.modelValue,
            locale: computed(() => props.locale || 'en'),
            attributes: [
                {
                    highlight: {
                        start: {
                            fillMode: 'solid',
                        },
                        base: {
                            fillMode: 'solid',
                        },
                        end: {
                            fillMode: 'solid',
                        },
                        style: {
                            backgroundColor: '#00adef',
                        },
                    },
                },
            ],
            modelConfig: {
                start: {
                    timeAdjust: '00:00:00',
                },
                end: {
                    timeAdjust: '23:00:00',
                },
            },
        });
        const close = () => {
            emit('close');
        };
        const apply = () => {
            emit('update:modelValue', state.value);
            close();
        };
        const ok = () => {
            if (props.validate) {
                if (props.validate(state.value, props.modelValue)) {
                    apply();
                }
                return;
            }
            apply();
        };
        watch(() => props.open, () => {
            if (props.open)
                state.value = props.modelValue;
        });
        return {
            state,
            ok,
            close,
        };
    },
});
